export default (arr: any []) => {
  const unique = new Set(arr)
  return Array.from(unique)
}



// WEBPACK FOOTER //
// ./src/utils/unique.ts